import React from 'react';
import * as GA from 'app/services/google-analytics';
import MarkdownViewer from 'app/components/markdown-viewer';
import SEO from 'app/components/seo';
import settings from 'configurations/app';

import content from './skills.md';

const Skills: React.FunctionComponent<Record<string, unknown>> = () => {
  const title = `${settings.title}' skills`;
  const description = '';
  const placeholder = 'skills';

  React.useEffect(() => {
    GA.sendPageView('skills');
  }, []);

  return (
    <div className="row">
      <SEO title={title} description={description} />
      <div className="col-12">
        <h1>{placeholder}</h1>
      </div>
      <div className="col-12">
        <MarkdownViewer content={content} />
      </div>
    </div>
  );
};

export default Skills;
